import Icon from 'components/shared/Icon/Icon';

import PHASES_CONFIG from '../../lib/phasesConfig';

const phaseMetaByCode = Object.fromEntries(PHASES_CONFIG.map((p) => [p.code, p]));

const PhaseHeader = ({ phase }) => {
  const meta = phaseMetaByCode[phase.code];
  const phaseIcon = meta?.icon;
  return (
    <li className="z-50 -mx-4 mt-3 flex h-12 items-center gap-2 bg-neutral-50 px-[22px] py-1 first:mt-0">
      {phaseIcon && <Icon icon={phaseIcon} size={36} />}
      <div className="flex flex-col">
        <span className="text-sm font-semibold leading-4 text-neutral-800">{phase.name}</span>
        {meta?.estimatedTime && (
          <span className="text-xs text-neutral-500">{meta.estimatedTime}</span>
        )}
      </div>
    </li>
  );
};

export default PhaseHeader;
